import { useEffect, useState } from "react";
import "../../assets/volunteers.css";
import eventLogo from "../../assets/eventLogo.png";
import StepButton from "../components/StepButton";
import { volunteerStatus } from "../../lib/services/authService";
import { useNavigate } from "react-router-dom";
import Options from "../components/Options";
import { getAllIncomplete } from "../../lib/utils/stencilWeekUtils";

import ModeDisplay from "../components/ModeDisplay";

// After they choose Tracing / Carving,
//  if only one stencil_week matches that step → go straight to timer
//  if multiple match → show Options so they can pick one

export default function VolunteerTimer({
  setIsVolunteerAuthenticated,
  volunteerName,
  stencilData,
  setTime,
  time,
}) {
  const [stencilWeek, setStencilWeek] = useState({});

  useEffect(() => {
    const checkVolunteerStatus = async () => {
      const response = await volunteerStatus();
      if (response.ok) {
        const data = await response.json();
        setIsVolunteerAuthenticated(data.isAuthenticated);
      }
    };

    checkVolunteerStatus();
  }, []);

  const navigate = useNavigate();

  // steps: enter → confirm (stencil) → mode (pick tracing/carving) → tracing|carving → complete
  const [step, setStep] = useState("mode");
  const [selectedMode, setSelectedMode] = useState(null); // "tracing" | "carving" | null

  // for Options page
  const [stencilWeeks, setStencilWeeks] = useState([]);
  const [candidateWeeks, setCandidateWeeks] = useState([]);

  useEffect(() => {
    // call getAllIncomplete if step goes back to "mode" to make sure stencil Weeks are updated
    if (step === "mode") {
      const fetchIncomplete = async () => {
        const allIncomplete = await getAllIncomplete(stencilData.stencil);
        setStencilWeeks(allIncomplete);
      };
      fetchIncomplete();
    }
  }, [step]);

  //Already completed effect
  useEffect(() => {
    if (!stencilWeek) return;

    if (step === "tracing" && stencilWeek.traced >= 2) {
      alert(
        "This stencil has already been marked as completed. Please select a different stencil; if you believe this is an error, please let event staff know."
      );
    } else if (step === "carving" && stencilWeek.carved >= 2) {
      alert(
        "This stencil has already been marked as completed. Please select a different stencil; if you believe this is an error, please let event staff know."
      );
    }
  }, [stencilWeek, step]);

  // confirm the chosen mode and decide whether to auto-pick or show Options page
  function confirmMode() {
    if (!selectedMode) return;

    // 1) Filter stencilWeeks by the chosen step & only those that still need work
    const relevant =
      selectedMode === "tracing"
        ? stencilWeeks.filter((sw) => Number(sw.traced) < 2)
        : stencilWeeks.filter((sw) => Number(sw.carved) < 2);

    // 2) If none match, nothing to do for this step
    if (relevant.length === 0) {
      alert(`This stencil has no available ${selectedMode} work.`);
      return;
    }

    // 3) If exactly one match → auto-select that stencil_week and go to timer
    if (relevant.length === 1) {
      setStencilWeek(relevant[0]);
      setStep(selectedMode); // "tracing" or "carving"
    } else {
      // 4) If multiple matches → show Options so volunteer can pick

      setCandidateWeeks(relevant);
      setStep("pick");
    }
  }

  return (
    <div className="vol-wrap">
      <div className="vol-stack">
        {/* Brand logo above the card */}
        <img
          src={eventLogo}
          alt="Spirits in the Gardens"
          className="vol-logo"
          loading="eager"
        />

        {/* WHITE CARD */}
        <div className="vol-card">
          {step === "pick" ? (
            <Options
              stencilWeeks={candidateWeeks}
              setStencilWeek={(sw) => {
                // When they click a card:
                setStencilWeek(sw); // choose that stencil_week
                setStep(selectedMode); // go into tracing or carving timer
              }}
              step={selectedMode}
            />
          ) : (
            <ModeDisplay
              step={step}
              stencilData={stencilData}
              setSelectedMode={setSelectedMode}
              selectedMode={selectedMode}
              stencilWeek={stencilWeek}
              time={time}
            />
          )}
        </div>

        {/* BUTTONS OUTSIDE THE CARD */}
        <div
          className={`vol-actions-outside ${
            step === "tracing" || step === "carving" ? "grid-3" : "grid-2"
          } ${step === "pick" ? "center" : ""}`}
        >
          {step === "mode" && (
            <>
              <button
                className="vol-btn primary"
                disabled={!selectedMode}
                onClick={confirmMode}
              >
                Confirm Choice
              </button>
              <button
                className="vol-btn ghost"
                onClick={() => {
                  navigate("/volunteer/confirm");
                }}
              >
                Back
              </button>
            </>
          )}

          {step === "pick" && (
            <button
              className="vol-btn ghost"
              onClick={() => {
                setStep("mode");
                setSelectedMode(null);
                setStencilWeek({});
                setCandidateWeeks([]);
              }}
            >
              Back
            </button>
          )}

          {step !== "mode" && step !== "pick" && (
            <StepButton
              selectedMode={step}
              setStencilWeek={setStencilWeek}
              stencilWeek={stencilWeek}
              setStep={setStep}
              volunteerName={volunteerName}
              setTime={setTime}
              navigate={navigate}
            />
          )}
        </div>
      </div>
    </div>
  );
}
